import type { CardHooks } from "./registry";

/**
 * Aegis the Defiant — passive: each time you take damage, gain 1 focus.
 * Triggered on round start: if you have less HP than opponent, gain 1 focus.
 */
export const aegisTheDefiant: CardHooks = {
  onDamageTaken: (ctx) => {
    const { self, damageTaken } = ctx;
    if (!damageTaken || damageTaken <= 0) return {};
    if (!self.armorActive) return {};
    return {
      focusGrant: 1,
      log: ["Aegis the Defiant — +1 focus on damage taken"],
    };
  },
  onRoundStart: (ctx) => {
    if (!ctx.self.armorActive) return {};
    if (ctx.self.health < ctx.opponent.health) {
      return {
        focusGrant: 1,
        log: ["Aegis the Defiant — Comeback +1 focus"],
      };
    }
    return {};
  },
};
